<template>
  <div>
    <div v-if="getFilter.list.length">
      <p class="cnt"><span class="colorPrimary f_medium">{{amenity.length}}</span> <span class="colorGrey"> / {{list.length}}</span></p>
      <div class="amenityList">
        <AmenityItem class="item"
          v-for="(item, index) in amenity"
          :key="item.raCode"
          :locale="locale"
          :localeAmenity="localeAmenity"
          :item="item"
          :index="index"
          :isCurrent="isCurrent(index)"
          :zIndex="zIndex(index)"
          @setZIndex="setZIndex" />
      </div>
    </div>
    <div class="noData"
      v-else>{{locale.amenity_select_category}}</div>
  </div>
</template>

<script>
import regExp from '@/common/regExp'
import AmenityItem from '@/components/Amenity/Item.vue'

export default {
  props: [
    'locale',
    'list'
  ],
  components: {
    AmenityItem
  },
  computed: {
    localeAmenity () {
      return this.$store.state.service.localeAmenity.data
    },
    listView () {
      return this.$store.state.amenity.listView
    },
    getFilter () {
      return this.$store.getters['amenity/getFilter']
    },
    amenity () {
      const category = this.getFilter.list
      const word = regExp.replaceAllEmpty(this.getFilter.word)
      const viewOption = this.listView
      // 서비스 상태 필터
      function listService (arr) {
        return arr.filter(x => {
          const serviceOn = viewOption.serviceOn && x.service
          const serviceOff = viewOption.serviceOff && !x.service
          return serviceOn || serviceOff
        })
      }
      // 요청가능 상태 필터
      function listEnabled (arr) {
        return arr.filter(x => {
          const disabled = viewOption.disabled && x.disabled
          const enabled = viewOption.enabled && !x.disabled
          return disabled || enabled
        })
      }
      function listView (arr) {
        return listEnabled(listService(arr))
      }
      // 상태 필터 후 전체 리스트 리턴
      let list = this.list ? listView(this.list) : []
      if (word && word.length > 0) {
        // 검색어
        list = list.filter(x => {
          return (x.keyword && regExp.replaceAllEmpty(x.keyword.join('|')).includes(word)) || // common 키워드를 모아 검색어 조회
          (x.label && regExp.replaceAllEmpty(Object.values(x.label).join('|')).includes(word)) // 각 아이템 label을 모아 검색어 조회
        })
      }
      if (category) {
        // 카테고리
        list = list.filter(x => category.includes(x.category))
      }
      return list
    },
    zIndex () {
      return (index) => {
        let zIndex = this.amenity.length - index
        if (this.isClick && this.isClick === index) {
          zIndex = zIndex * 10
        }
        return zIndex
      }
    },
    isCurrent () {
      return (index) => {
        return this.isClick === index
      }
    }
  },
  data () {
    return {
      isClick: null
    }
  },
  methods: {
    setZIndex (index) {
      this.isClick = index
    }
  }
}
</script>

<style lang="scss" scoped>
.cnt {
  margin-bottom: 0.5em;
  text-align: right;
}
.noData {
  padding: 120px 30px 200px;
  text-align: center;
  font-size: 1.2em;
  &:before {
    content: "";
    display: block;
    height: 64px;
    margin-bottom: 30px;
    background: url('~@/assets/img/ico_search.svg') 50% 50% / contain no-repeat;
    opacity: 0.2;
  }
}
</style>
